/**
 *
 * @param ( routerName: generator01 , mcyCode: DG01 )
 * @returns
 */
export const routerNameChanger = (routerName?: string) => {
  let mcyCode;
  switch (routerName) {
    case "NO.1 발전기":
      routerName = "generator01";
      mcyCode = "DG01";
      break;
    case "NO.2 발전기":
      routerName = "generator02";
      mcyCode = "DG02";
      break;
    case "NO.3 발전기":
      routerName = "generator03";
      mcyCode = "DG03";
      break;
    case "NO.4 발전기":
      routerName = "generator04";
      mcyCode = "DG04";
      break;
    case "가스터빈":
      routerName = "gas-turbine";
      mcyCode = "GT";
      break;
    // Add more cases as needed
  }
  return { routerName, mcyCode };
};
